<template>

    <div class="chart-dog-legend-label">

        <div :class="`phase-${phaseIndex} ${phaseIndex == null ? 'no-phase' : ''}`">
            <svg width="20" height="20"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlns:svg="http://www.w3.org/2000/svg">
                <g class="layer">
                    <!-- series line -->
                    <path d="m0,10l20,0" fill="none"
                          :stroke="`${seriesColorCode}`"
                          stroke-width="2"/>

                    <!-- marker: circle -->
                    <path v-if="seriesShape == 'circle'"
                          d="m14,10a4,4 0 1 1 0,-0.004l0,0.004z"
                          fill="`${seriesColorCode}`"/>

                    <!-- marker: square -->
                    <path v-if="seriesShape == 'square'"
                          d="M 7 6 L 14 6 14 14 7 14 Z" f
                          ill="`${seriesColorCode}`"/>

                    <!-- marker: triangle -->
                    <path v-if="seriesShape == 'triangle'"
                          d="M 10 6 L 14 14 6 14 Z"
                          fill="`${seriesColorCode}`"/>

                    <!-- marker: diamond -->
                    <path v-if="seriesShape == 'diamond'"
                          d="M 10 6 L 14 10 10 14 6 10 Z"
                          fill="`${seriesColorCode}`"/>
                </g>
            </svg>
        </div>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ChartDogLegendLabel",
        mixins: [ToolMixin],
        props: {
            seriesShape: String,
            seriesColorCode: String,
            phaseIndex: Number
        }
    })

</script>

<style lang="scss">

    .chart-dog-legend-label {
        display: inline-block;
        position: relative;
        height: 24px;
        padding: 0 10px;
        border: solid 1px #ccc;
        border-radius: 3px;

        svg {
            padding-top: 2px;
        }

        &.no-phase {
            border: none;
        }
    }

</style>

